'use strict';

(function() {
	angular.module('onboarding.broker.contracts')
		.directive('cobContractVersionsList', cobContractVersionsList);

	cobContractVersionsList.$inject = [
		'subjectObserverMessagesService', 'observerService', 'contractService', '$log', '$location', 'sessionService',
		'$state', '$stateParams'
	];

	var subjectObserverMessagesService,
		observerService,
		contractService,
		subjectMessages,
		observerMessages,
		rowCount,
		$log,
		$location,
		sessionService,
		$state,
		$stateParams;

	function cobContractVersionsList(_subjectObserverMessagesService_,
		_observerService_,
		_contractService_,
		_$log_,
		_$location_,
		_sessionService_,
		_state_,
		_$stateParams_) {
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		contractService = _contractService_;
		rowCount = 100;
		$log = _$log_;
		$location = _$location_;
		sessionService = _sessionService_;
		$state = _state_;
		$stateParams = _$stateParams_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/broker/contracts/contractVersionList.html',
			link: linkFunction,
			bindToController: true
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {

			if (sessionService.isAuthorizedInternalAdmin() && !$stateParams.brokerId) {
				$state.go('brokersAdmin');

				return;
			}

			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();
			registerEventHandlers();

			scope.$stateParams = $stateParams;
			scope.m = {
				errors: [],
				showDeleteContractModal: false
			};
			scope.versions = [];
			scope.sortReverse = false;
			scope.sortType = 'uploadDate';
			var contractId = $location.search()['contractid'];
			if (contractId) {
				scope.contractId = parseFloat(contractId);
			}

			scope.showDeleteConfirmation = {
				showDeleteConfirmation: false,
				contractId: undefined
			};
			scope.deleteContract = deleteContract;
			scope.deleteContractHideConfirm = deleteContractHideConfirm;
			scope.deleteContractShowConfirm = deleteContractShowConfirm;
			scope.descriptionClicked = descriptionClicked;
			scope.saveDescription = saveDescription;
			scope.getVersions = getVersions;
			scope.setActive = setActive;
			scope.sortClicked = sortClicked;

			getDetails();
			document.title = 'Contract Versions';
		}

		function registerEventHandlers() {
			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_FILE_UPLOAD_SUCCESS, handler: onFileUploadSuccess },
					{ message: observerMessages.COB_OBSERVER_FILE_UPLOAD_SAVED, handler: onFileUploadSave }
					//,{ message: observerMessages.COB_OBSERVER_FILE_UPLOAD_ERROR, handler: onError }
				]);
		}

		function deleteContract() {
			setTimeout(function () {
				observerService.sendMessageToSubject(scope, subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
			}, 1);

			contractService.deleteContract(scope.showDeleteConfirmation.contractId)
				// .then(function(response) {

				// 	scope.versions = response.data.versions;
				// })
				.catch(function(e) {
					console.log(e);
				})
				.finally(function() {
					scope.showDeleteConfirmation.showDeleteConfirmation = false;
					scope.showDeleteConfirmation.contractId = undefined;
					getVersions();
					observerService.sendMessageToSubject(scope, subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
				});

		}

		function deleteContractHideConfirm() {
			scope.showDeleteConfirmation.showDeleteConfirmation = false;
			scope.showDeleteConfirmation.contractId = undefined;
		}

		function deleteContractShowConfirm(version) {
			scope.showDeleteConfirmation.showDeleteConfirmation = true;
			scope.showDeleteConfirmation.contractId = version.contractId;
		}

		function descriptionClicked(version) {
			if (version.isLatest) {
				scope.oldValue = version.description;
				version.editMode = !version.editMode || true;
			}
		}

		function getVersions() {
			setTimeout(function() {
				observerService.sendMessageToSubject(scope,
					subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
			},
			1);

			contractService.getContractVersions(scope.contract.contractName)
				.then(function(response) {
					scope.versions = response.data.contracts;
					if (scope.versions.length > 0) {
						scope.versions[0].isLatest = true;
						scope.newContract.contractId = scope.versions[0].contractId;
						$location.search('contractid', scope.newContract.contractId);
					} else // no versions found
					{
						$state.go('contracts',{ brokerId: $stateParams.brokerId });
					}
				})
				.catch(function(e) {
					console.log(e);
					// alert('Unable to retrieve carriers');
				})
				.finally(function() {
					observerService.sendMessageToSubject(scope,
						subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
				});

			return;
		}

		function getDetails() {
			if (scope.contractId) {
				setTimeout(function () {
					observerService.sendMessageToSubject(scope, subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
				}, 1);

				contractService.getContractDetail(scope.contractId)
					.then(function(response) {
						scope.contract = response.data;
						observerService
							.sendMessageToSubject(scope,
								subjectMessages.COB_SUBJECT_CONTRACT_GROUP_SELECTED,
								scope.contract);
						getVersions();

						if (!scope.newContract) {
							scope.newContract = {};
						}
						scope.newContract.contractId = scope.contractId;
						scope.newContract.contractName = scope.contract.contractName;

					})
					.catch(function(e) {
						console.log(e);
					}).finally(function () {
						observerService
							.sendMessageToSubject(scope, subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
					});
			} else // cannot load a contract whithout the ID
			{
				$location.search('contractid', null);
				$location.path('/contracts');
			}

			return;
		}

		function saveDescription(contract) {

			setTimeout(function () {
				observerService.sendMessageToSubject(scope, subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
			}, 1);

			contractService.updateContractDescription(contract.contractId, contract.name, contract.description)
				.then(function() {
				})
				.catch(function(res) {
					var modelErrors = res.data.modelState;
					var errors = [];
					for (var key in modelErrors) {
						for (var i = 0; i < modelErrors[key].length; i++) {
							errors.push(modelErrors[key][i]);
						}
					}

					observerService.sendMessageToSubject(scope,
						subjectMessages.COB_SUBJECT_GENERIC_SERVER_ERROR,
						errors);
					scope.m.errors = errors;
				}).finally(function () {
					observerService
						.sendMessageToSubject(scope, subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
				});
		}

		function setActive(isActive) {
			if (!scope.contract) {
				scope.contract = {};
			}
			if (isActive) {
				scope.contract.status = 'ACTIVE';
			} else {
				scope.contract.status = 'INACTIVE';
			}

			setTimeout(function () {
				observerService.sendMessageToSubject(scope, subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
			}, 1);

			contractService.updateContractStatus(scope.contractId, scope.contract.status, scope.contract.contractName)
				// .then(function(response) {
				// 	scope.contract.status = response.data.status;
				// })
				.catch(function(e) {
					console.log(e);
					// Return To Original State
					if (!isActive) {
						scope.contract.status = 'ACTIVE';
					} else {
						scope.contract.status = 'INACTIVE';
					}
				}).finally(function () {
					observerService
						.sendMessageToSubject(scope, subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
				});

			return;
		}

		function sortClicked(sortType) {
			if (scope.sortType === sortType) {
				scope.sortReverse = !scope.sortReverse;

				return;
			} else {
				scope.sortType = sortType;
				scope.sortReverse = false;
			}
		}

		function onFileUploadSuccess() {
			scope.newContract.save();
		}

		function onFileUploadSave() {
			getVersions();
		}
	}
})();
